import { NextPage } from 'next';
import createEmailPasswordLoginPage from '../../react-components/login/create-login-page';

const BusinessLogin: NextPage = createEmailPasswordLoginPage(
  'Business Login',
  'business',
  'sessions/business',
  '/home/business',
  <>
    FITSOCIETY.COM can help you expand your business.
    <ul className='px-6 list-disc'>
      <li>
        <strong>Free</strong> business profile
      </li>
      <li>Platform to market your business</li>
      <li>Communicate your services</li>
      <li>Additional benefits available for Silver tier: logos/specials, Gold: banners, etc.</li>
    </ul>
  </>,
  '/business'
);

export default BusinessLogin;
